export default __webpack_public_path__ + "static/media/furniture-bg-4.52e8752c.png";